// Styles here will override Bulma styles
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import media from 'css-in-js-media';

export const styledTagNavItem = css`
  font-size: 14px;
  line-height: 17px;
  color: #5b6987;
  text-decoration: none;
`;

export const StyledTagNavContainer = styled.div`
  margin: 0;
  list-style: none;
  display: flex;
  align-items: center;
  position: relative;
  margin-top: 200px;
  margin-bottom: 40px;
  margin: 200px 60px 40px 60px;
  min-width: 240px;

  ${media('<tablet')} {
    display: none;
  }
`;

export const StyledSpan = styled.span`
  font-family: 'WorkSans-Bold', 'Helvetica', 'san-serif';
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #99a1b3;
  margin-bottom: 20px;
`;

export const StyledTagNavUl = styled.ul`
  margin: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  align-items: left;
  width: 240px;

  li {
    padding: 0;
    margin: 0;

    a {
      display: flex;
      padding: 12px 22px 11px 22px;
      font-family: 'WorkSans-Regular', 'Helvetica', 'san-serif';
    }
    a:hover {
      background: #f2f8ff !important;
      border-radius: 40px;
      color: #0069ff;
    }
  }
`;

export const StyledTagNavContainerMobile = styled.div`
  margin-top: 0;
  margin: 20px 0;
  width: 100vw;

  .hideOnMobile {
    display: none;
  }

  .dropdown-trigger {
    width: calc(100vw - 40px);
    margin: 20px 20px 0 20px;
    display: flex;

    button {
      width: 100%;
      height: 40px;
      border-radius: 0;
      border-color: #e5e8ed;
      display: flex;
      justify-content: space-between;
      font-family: 'WorkSans-Regular', 'Helvetica', 'san-serif';
      span:first-letter {
        text-transform: capitalize;
      }
    }
  }

  .dropdown-menu {
    width: 100%;
    .dropdown-content {
      margin: 0 20px;
      padding: 10px 0;

      a.dropdown-item {
        font-family: 'WorkSans-Regular', 'Helvetica', 'san-serif';
        margin: 0 12px;
        padding: 8px;
        :hover {
          border-radius: 2px;
          background: #f2f8ff !important;
        }
      }
    }
  }

  ${media('> desktop')} {
    display: none;
  }
`;
